import { Container, Typography, Box, Divider } from "@mui/material";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import Page from "../component/Page";
import ReusableTabs from "../component/ReusableTabs";
import Link from "next/link";

const outlook = [{
  label: "One month Drought Outlook",
  src: "https://www.cpc.ncep.noaa.gov/products/expert_assessment/month_drought.png"
}, {
  label: "Seasonal Drought Outlook",
  src: "https://www.cpc.ncep.noaa.gov/products/expert_assessment/season_drought.png"
}];

export default function Hydrology() {
  return (
    <Page>
      <img src="./background/hydrology.jpg" style={{ width: "100%", maxHeight: 250, objectFit: "cover", objectPosition: "center 75%" }}></img>
      <Container sx={{ py: 5 }}>
        <NextBreadcrumbs></NextBreadcrumbs>
        <Typography variant="h3">Hydrology</Typography>
        <Typography variant="body1" sx={{ textAlign: "justify", py: 3 }}>
          Kentucky has nearly 1,600 miles of waterways, carrying over 90 million
          tons of goods annually. Furthermore, the Commonwealth's many lakes and
          rivers form a popular weekend destination. Fortunately, Kentucky is
          blessed with generally abundant precipitation year-round, largely in
          the form of rainfall. The state averages between 42 and 52 inches per
          year with increasing amounts from southwest to northeast.
          Nevertheless, droughts and floods are common, with periods of flooding
          most common during the winter and spring, and droughts most common
          during summer and fall. Accurate monitoring of precipitation,
          understood in the context of short- and long-term climatic
          fluctuations, aids our mitigation efforts with farmers, river
          engineers, and water treatment centers, among others, to better
          navigate our region's water needs, including water access, quality,
          and treatment.
        </Typography>
        <Typography sx={{ textAlign: "justify" }} paragraph>NIDIS Drought Maps:
          <Link href={"https://www.drought.gov/states/kentucky"}> https://www.drought.gov/states/kentucky</Link>
        </Typography>
        <Box>
          <Typography variant="h4">Streamflow Map (USGS)</Typography>
          <iframe
            src="https://dashboard.waterdata.usgs.gov/app/nwd/en/?aoi=state-ky&view=%7B%22basemap%22%3A%22EsriTopo%22%2C%22bounds%22%3A%22-90.65056252391234%2C35.373020110001846%2C-78.53538456105298%2C40.235720227820984%22%2C%22insetMap%22%3Afalse%2C%22panel%22%3A%7B%22checkbox%22%3A%220%2C9%2C19%2C20%2C21%2C22%22%2C%22range%22%3A%220%3A1.0%2C1%3A1.0%2C2%3A1.0%2C3%3A1.0%2C4%3A1.0%2C5%3A1.0%2C6%3A1.0%2C7%3A0.8%2C8%3A0.3%2C9%3A0.5%2C10%3A0.5%2C11%3A0.5%2C12%3A0.5%2C13%3A0.5%2C14%3A0.5%2C15%3A0.5%2C16%3A1.0%2C17%3A1.0%2C18%3A1.0%2C19%3A1.0%22%2C%22select%22%3A%220%3A0%2C1%3A0%2C2%3A0%2C3%3A0%2C4%3A0%2C5%3A0%2C6%3A0%2C7%3A0%2C8%3A0%2C9%3A0%2C10%3A0%2C11%3A0%2C12%3A0%2C13%3A0%2C14%3A0%2C15%3A0%2C16%3A0%2C17%3A0%2C18%3A0%22%7D%7D "
            style={{ width: "100%", height: 650, minHeight: 650, border: 0 }}
          ></iframe>
          {/* <Divider sx={{ my: 5 }}></Divider> */}
          {/* <iframe src="https://water.weather.gov/ahps/?current_color=flood&current_type=all&fcst_type=obs&conus_map=d_map"
            style={{ width: "100%", height: 650, minHeight: 650, border: 0 }}
          ></iframe> */}

          <Divider sx={{ my: 5 }}></Divider>
          <iframe src="https://droughtmonitor.unl.edu/" style={{ width: "100%", height: 650, minHeight: 650, border: 0 }}></iframe>
          <Divider sx={{ my: 5 }}></Divider>
          <ReusableTabs
            items={outlook}
            panelHeight={700}
          ></ReusableTabs>
        </Box>
      </Container>
    </Page>
  );
}